import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {RouterModule} from "@angular/router";
import {CreateEditUserComponent} from "./users/create-edit-user/create-edit-user.component";
import {FundingGoalsManagementComponent} from "./users/funding-goals-management/funding-goals-management.component";
import {SavedSearchesContainerComponent} from "./users/saved-searches-management/saved-searches-container/saved-searches-container.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {LoginComponent} from "./login/login.component";
import {LoggedOutComponent} from "./logged-out/logged-out.component";
import {UnauthorizedComponent} from "./unauthorized/unauthorized.component";
import {SubscriptionManagementComponent} from "./users/subscription-management/subscription-management.component";
import {UserViewComponent} from "./users/user-view/user-view.component";
import {HomePageComponent} from "./home-page/home-page.component";
import {ApiService} from "../services/api.service";
import {AuthService} from "../services/auth.service";
import {StUiComponentsModule} from "../shared-components/ui-components/st-ui-components.module";
import {
  NonprofitsDonorsListingComponent
} from "./search-nonprofits-donors/nonprofits-donors-listing/nonprofits-donors-listing.component";
import {
  NonprofitsDonorsDetailsComponent
} from "./search-nonprofits-donors/search-nonprofits-donors-details/nonprofits-donors-details.component";
import {UserService} from "./users/services/users.service";
import {
  FundingGoalsListingComponent
} from "./users/funding-goals-management/funding-goals-listing/funding-goals-listing.component";
import {DashboardComponent} from "./users/dashboard/dashboard.component";
import {ChangePasswordComponent} from "./users/change-password/change-password.component";
import {
  SavedSearchesListingComponent
} from "./users/saved-searches-management/saved-searches-listing/saved-searches-listing.component";
import {SearchService} from "./search-nonprofits-donors/services/search.service";
import {Auth2Service} from "../services/auth2.service";
import {
  SubscriptionPaymentComponent
} from "./users/subscription-management/subscription-payment/subscription-payment.component";
import {
  SearchNonprofitsPageComponent
} from "./search-nonprofits-donors/search-nonprofits-page/search-nonprofits-page.component";
import {
  SearchNonprofitsDetailsComponent
} from "./search-nonprofits-donors/search-nonprofits-details/search-nonprofits-details.component";
import {
  SearchDonorsPageComponent
} from "./search-nonprofits-donors/search-donors-page/search-donors-page.component";
import {
  SearchDonorsDetailsComponent
} from "./search-nonprofits-donors/search-donors-details/search-donors-details.component";
import {SearchGrantsDetailsComponent} from "./search-grants/search-grants-details/search-grants-details.component";
import {SearchGrantsListingComponent} from "./search-grants/search-grants-listing/search-grants-listing.component";
import {SearchGrantsPageComponent} from "./search-grants/search-grants-page/search-grants-page.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {ForgotUsernameComponent} from "./forgot-username/forgot-username.component";
import {ResetPasswordRequestComponent} from "./reset-password/reset-password-request/reset-password-request.component";
import {ResetPasswordService} from "./reset-password/services/reset-password.service";
import {SearchGrantsService} from "./search-grants/services/search-grants.service";
import {ForgotUsernameService} from "./forgot-username/services/forgot-username.service";
import {
  SavedSearchesDonorCreateEditComponent
} from "./users/saved-searches-management/saved-searches-create-edit/saved-searches-donor-create-edit/saved-searches-donor-create-edit.component";
import {
  SavedSearchesGrantCreateEditComponent
} from "./users/saved-searches-management/saved-searches-create-edit/saved-searches-grant-create-edit/saved-searches-grant-create-edit.component";
import {
  SavedSearchesNonprofitCreateEditComponent
} from "./users/saved-searches-management/saved-searches-create-edit/saved-searches-nonprofit-create-edit/saved-searches-nonprofit-create-edit.component";
import {CreateViewWishlistComponent} from "./users/wishlist/create-view-wishlist/create-view-wishlist.component";
import {WishListListingComponent} from "./users/wishlist/wishlist-listing/wishlist-listing.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {SuccessfulPaymentComponent} from "./users/subscription-management/success-payment/successful-payment.component";
import {CanceledPaymentComponent} from "./users/subscription-management/canceled-payment/canceled-payment.component";
import {
  SubscriptionChangeComponent
} from "./users/subscription-management/subscription-change/subscription-change.component";
import {
  SuccessfulSubscriptionChangeComponent
} from "./users/subscription-management/success-subscription-change/successful-subscription-change.component";
import {
  ResetPasswordEmailSentComponent
} from "./reset-password/reset-password-email-sent/reset-password-email-sent.component";
import {KeyStaffDropdownCacheService} from "./dropdown-cache-services/key-staff-dropdown-cache.service";
import {DonorNamesCacheService} from "./dropdown-cache-services/donor-names-cache.service";
import {NonprofitNamesCacheService} from "./dropdown-cache-services/nonprofit-names-cache.service";
import {
  CreateConsultantProfileComponent
} from "./users/create-approved-consultant-profile/create-consultant-profile.component";
import {ConsultantSelectAccountComponent} from "./users/consultant-select-account/consultant-select-account.component";
import {EditConsultantUserComponent} from "./users/edit-consultant-user/edit-consultant-user.component";
import {CreateConsultantUserComponent} from "./users/create-consultant-user/create-consultant-user.component";
import {
  SuccessfulConsultantCreationComponent
} from "./users/create-approved-consultant-profile/successful-consultant-creation/successful-consultant-creation.component";
import {
  SuccessfulConsultantCheckoutComponent
} from "./users/subscription-management/success-consultant-checkout/successful-consultant-checkout.component";
import {
  CanceledConsultantCheckoutComponent
} from "./users/subscription-management/canceled-consultant-checkout/canceled-consultant-checkout.component";
import {
  ConsultantAlreadyHasAccountComponent
} from "./users/subscription-management/consultant-already-has-account/consultant-already-has-account.component";
import {
  SuccessfulPaymentMethodSavedComponent
} from "./users/subscription-management/success-payment-method-saved/successful-payment-method-saved.component";
import {
  CanceledPaymentMethodSaveComponent
} from "./users/subscription-management/canceled-payment-method-save/canceled-payment-method-save.component";
import {EmailVerificationComponent} from "./users/dashboard/email-verification/email-verification.component";

@NgModule({
  declarations: [
    ConsultantSelectAccountComponent,
    ChangePasswordComponent,
    CreateConsultantProfileComponent,
    CreateConsultantUserComponent,
    CreateEditUserComponent,
    DashboardComponent,
    EditConsultantUserComponent,
    EmailVerificationComponent,
    FundingGoalsManagementComponent,
    HomePageComponent,
    SavedSearchesContainerComponent,
    SavedSearchesDonorCreateEditComponent,
    SavedSearchesGrantCreateEditComponent,
    SavedSearchesNonprofitCreateEditComponent,
    SearchGrantsDetailsComponent,
    SearchGrantsListingComponent,
    SearchGrantsPageComponent,
    SuccessfulPaymentComponent,
    SuccessfulConsultantCheckoutComponent,
    CanceledConsultantCheckoutComponent,
    ConsultantAlreadyHasAccountComponent,
    SuccessfulPaymentMethodSavedComponent,
    SuccessfulConsultantCreationComponent,
    CanceledPaymentMethodSaveComponent,
    CanceledPaymentComponent,
    PageNotFoundComponent,
    LoginComponent,
    LoggedOutComponent,
    UnauthorizedComponent,
    ForgotUsernameComponent,
    ResetPasswordComponent,
    ResetPasswordRequestComponent,
    ResetPasswordEmailSentComponent,
    SavedSearchesListingComponent,
    SubscriptionManagementComponent,
    SubscriptionChangeComponent,
    SuccessfulSubscriptionChangeComponent,
    SubscriptionPaymentComponent,
    SearchNonprofitsPageComponent,
    SearchDonorsPageComponent,
    SearchNonprofitsDetailsComponent,
    SearchDonorsDetailsComponent,
    UserViewComponent,
    NonprofitsDonorsListingComponent,
    NonprofitsDonorsDetailsComponent,
    FundingGoalsListingComponent,
    CreateViewWishlistComponent,
    WishListListingComponent
  ],
  exports: [
    ConsultantSelectAccountComponent,
    ChangePasswordComponent,
    CreateConsultantProfileComponent,
    CreateConsultantUserComponent,
    CreateEditUserComponent,
    ConsultantAlreadyHasAccountComponent,
    DashboardComponent,
    EditConsultantUserComponent,
    EmailVerificationComponent,
    FundingGoalsManagementComponent,
    HomePageComponent,
    ResetPasswordEmailSentComponent,
    SavedSearchesListingComponent,
    SavedSearchesContainerComponent,
    SavedSearchesDonorCreateEditComponent,
    SavedSearchesGrantCreateEditComponent,
    SavedSearchesNonprofitCreateEditComponent,
    SearchGrantsDetailsComponent,
    SearchGrantsListingComponent,
    SearchGrantsPageComponent,
    CanceledPaymentMethodSaveComponent,
    SuccessfulPaymentMethodSavedComponent,
    PageNotFoundComponent,
    LoginComponent,
    LoggedOutComponent,
    UnauthorizedComponent,
    ForgotUsernameComponent,
    ResetPasswordComponent,
    ResetPasswordRequestComponent,
    SuccessfulPaymentComponent,
    SuccessfulConsultantCheckoutComponent,
    CanceledConsultantCheckoutComponent,
    CanceledPaymentComponent,
    SuccessfulSubscriptionChangeComponent,
    SubscriptionManagementComponent,
    SubscriptionPaymentComponent,
    SearchNonprofitsPageComponent,
    SearchDonorsPageComponent,
    SearchNonprofitsDetailsComponent,
    SearchDonorsDetailsComponent,
    SuccessfulConsultantCreationComponent,
    UserViewComponent,
    NonprofitsDonorsListingComponent,
    NonprofitsDonorsDetailsComponent,
    FundingGoalsListingComponent,
    CreateViewWishlistComponent,
    WishListListingComponent
  ],
    imports: [BrowserModule, NgbModule,
        RouterModule, StUiComponentsModule
    ],
  providers: [AuthService, Auth2Service, UserService, SearchService,
    SearchGrantsService, ResetPasswordService, ForgotUsernameService, ApiService,
    KeyStaffDropdownCacheService, DonorNamesCacheService, NonprofitNamesCacheService],
  bootstrap: []
})
export class PagesModule {}
